// extracted by mini-css-extract-plugin
export var dividerLine = "_4d-0";
export var errorBackground = "_4d-1";